import { Box, CircularProgress, useMediaQuery } from "@mui/material";
import React, { useMemo, useState } from "react";
import { usePlacesData } from "../../../hooks/usePlacesData";
import DetailCard from "../DetailCard/DetailCard";
import LoadMoreButton from "../LoadMoreButton/LoadMoreButton";
import PlacesList from "../PlacesList/PlacesList";
import SearchField from "../SearchField/SearchField";
import { useTranslation } from "react-i18next";

const Places: React.FC = () => {
  const { t } = useTranslation();
  const { places, loading } = usePlacesData(t, true);
  const [search, setSearch] = useState("");
  const [selectedPlaceIndex, setSelectedPlaceIndex] = useState<number | null>(
    null
  );
  const [visibleCount, setVisibleCount] = useState(10);
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const stablePlaces = useMemo(() => [...places], [places]);
  const filteredPlaces = stablePlaces.filter((place) =>
    place.placeName?.toLowerCase().includes(search.toLowerCase())
  );
  const displayedPlaces = filteredPlaces.slice(0, visibleCount);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="50vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const handleNext = () => {
    if (selectedPlaceIndex === null) return;
    setSelectedPlaceIndex((selectedPlaceIndex + 1) % filteredPlaces.length);
  };

  const handlePrev = () => {
    if (selectedPlaceIndex === null) return;
    setSelectedPlaceIndex(
      (selectedPlaceIndex - 1 + filteredPlaces.length) % filteredPlaces.length
    );
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "30vh",
          padding: 2,
        }}
      >
        <Box
          width="100%"
          p={2}
          display="flex"
          flexDirection="column"
          alignItems="center"
          mb={3}
          mt={-3}
        >
          <SearchField
            search={search}
            setSearch={(value) => {
              setSearch(value);
              setVisibleCount(10);
            }}
            placesCount={places.length}
          />

          <PlacesList
            places={places}
            displayedPlaces={displayedPlaces}
            setSelectedPlaceIndex={setSelectedPlaceIndex}
            isSmallScreen={isSmallScreen}
          />

          {visibleCount < filteredPlaces.length && (
            <LoadMoreButton
              onClick={() => setVisibleCount((prev) => prev + 10)}
            />
          )}
        </Box>
      </Box>

      {selectedPlaceIndex !== null && (
        <DetailCard
          place={filteredPlaces[selectedPlaceIndex]}
          onClose={() => setSelectedPlaceIndex(null)}
          onNext={handleNext}
          onPrev={handlePrev}
          hideControls={true}
        />
      )}
    </>
  );
};

export default Places;
